import { Component, OnInit }       from '@angular/core';
import { Params, Router }  from '@angular/router';
import { Location }        from '@angular/common';

import { CallService } from '../services/calls/call.service';
import { FilterService } from '../services/calls/filter.service';
import { ProviderService } from '../services/providers/provider.service';


import { Call } from '../classes/call';

import { AllCallsComponent } from './allCalls.component';
import { DoctorService } from '../services/doctors/doctor.service';
import { SpecialtiesService } from '../services/specialties/specialties.service';
import { AppConfig } from '../app.config';
import { Auth } from '../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-calls',
  templateUrl: 'calls.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class CallsComponent extends AllCallsComponent implements OnInit{

  constructor(protected callService: CallService,
              protected location: Location,
              protected router: Router,
              protected filterService:FilterService,
              protected specialtiesService:SpecialtiesService,
              protected doctorsService: DoctorService,
              protected providerService:ProviderService,
              protected config: AppConfig,
              protected auth: Auth) {
                  super(callService,location,router,filterService,providerService,specialtiesService,doctorsService,callService,config, auth);
              }

  solved(call){
    console.log(call)
  }

  create(){
    this.router.navigate([ '/createCall' ]);
  }

}



// WEBPACK FOOTER //
// ./src/app/calls/calls.component.ts